<script>

import { PDFDocument, PDFTextField, PDFCheckBox, PDFDropdown, PDFOptionList, PDFButton } from 'pdf-lib';

export default {
  props: ['item', 'compiledOutput'],
  components: {  },
  data() {
    return {
      active_pdf: "",
      iframedata: "",
      iframeWidth: 100,
      iframeHeight: 70,

      loading: false,
    }
  },
  computed: {
    computedPdfs: function() {
      var output = [];
      if(this.item.mls && this.item.mls.pdfs) {
        for(var i in this.item.mls.pdfs) {
          if(!this.active_pdf && i == 0) { this.active_pdf = this.item.mls.pdfs[i].pdf_url; this.startup(); }
          output.push({name: this.item.mls.pdfs[i].title, value: this.item.mls.pdfs[i].pdf_url});
        }
      }
      return output;
    },
  },
  created() {
    
  },
  methods: {
    async startup(evt) {
      this.loading = true;
      if(this.disabled == true) { this.$noty.warning('Disabled'); return; } this.disabled = true;
      if(this.active_pdf) {
        this.$http.get('/api/mlss/pdfs/fetchpdf', {params: {url: this.active_pdf}, responseType: 'arraybuffer'}).then(res => {
          var myData = new Uint8Array(res.data);
          (async() => {
            const pdfDoc = await PDFDocument.load(myData);
            const form = pdfDoc.getForm();
            const fields = form.getFields();
            fields.forEach(field => {
              const type = field.constructor.name; // Doesn't work when JS is compiled. Use "field instanceof PDFTextField" instead.
              const name = field.getName();
              // console.log(`${type}: ${name}`);
              // PDFTextField
              // PDFSignature
              // PDFCheckBox
              // PDFDropdown
              // PDFOptionList
              // PDFRadioGroup

              // For testing
              // if(type == 'PDFTextField') { field.setText(name); }
              // if(type == 'PDFCheckBox') { field.check(); }
              // if(type == 'PDFDropdown') { field.addOptions([name]); field.select(name); }
              // if(type == 'PDFOptionList') { field.addOptions([name]); field.select(name); }

              // Live
              if(this.compiledOutput.hasOwnProperty(name)) {
                if(field instanceof PDFTextField) {
                  field.setText(this.compiledOutput[name].output);
                } else if(field instanceof PDFCheckBox) {
                  if(this.compiledOutput[name].output) { field.check(); } else { field.uncheck(); }
                } else if(field instanceof PDFDropdown || field instanceof PDFOptionList) {
                  const options = field.getOptions();
                  if(options.includes(this.compiledOutput[name].output)) { field.select(this.compiledOutput[name].output); } else { field.clear(); }
                }
              }
            });
            const pdfBytes = await pdfDoc.save();
            const blobObj = new Blob([pdfBytes], { type: "application/pdf" })
            const docUrl = URL.createObjectURL(blobObj);
            this.iframedata = docUrl;
            this.disabled = false;
            this.loading = false;
          })();
        }).catch(res => { this.popupErrors(res); this.disabled = false; this.loading = false; });
      }
    },
  }
}
</script>


<template>
  <div>
    <div class="row">
      <div class="col-sm-2">
        <w-field SimpleDataType="Number" Title="Width : " Min="5" Max="100" v-model="iframeWidth"></w-field>
      </div>
      <div class="col-sm-2">
        <w-field SimpleDataType="Number" Title="Height : " Min="5" Max="100" v-model="iframeHeight"></w-field>
      </div>
      <div class="col-sm-8">
        <div class="input-group">
          <w-field SimpleDataType="String List, Single" Title="PDF : " style="flex: 1;" :Options="computedPdfs" v-model="active_pdf"></w-field>
          <div class="input-group-append flex-column justify-content-end mb-2">
            <button type="button" class="btn btn-success" @click="startup"><span class="spinner-border spinner-border-sm" v-if="loading"></span> <Icon icon="ri:save-line" /> Load</button>
          </div>
        </div>
      </div>
    </div>
    <iframe :src="iframedata" frameborder="0" :style="'width:'+iframeWidth+'%;'+'height:'+iframeHeight+'vh;'+'box-shadow: 0 0 10px rgba(0,0,0,0.5);border-radius:5px;'"></iframe>
  </div>
</template>
